import { SITE } from "@/lib/site";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative bg-black border-t border-[#161616] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black uppercase text-white tracking-tighter leading-[0.9]">
              Let's
              <br />
              <span className="text-[#1E5BFF]">Move It.</span>
            </h2>
            <p className="mt-6 text-slate-400 max-w-md leading-relaxed">
              Heavy haul, hotshot, equipment, flatbed, cross-border. One call — Coreline handles
              the rest.
            </p>
            <a
              href="#quote"
              data-testid="footer-cta-quote"
              className="btn-slash inline-block mt-8 bg-[#1E5BFF] hover:bg-[#3B72FF] text-white font-display font-bold uppercase tracking-[0.18em] text-sm px-10 py-4"
            >
              Request a Quote
            </a>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-xs font-bold uppercase tracking-[0.3em] text-[#1E5BFF] mb-5">
              Contact
            </h4>
            <ul className="space-y-4 text-sm text-slate-300">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#1E5BFF] mt-0.5" />
                <a
                  href={`tel:${SITE.contact.phone.replace(/\D/g, "")}`}
                  data-testid="footer-phone"
                  className="hover:text-white transition-colors"
                >
                  {SITE.contact.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#1E5BFF] mt-0.5" />
                <a
                  href={`mailto:${SITE.contact.email}`}
                  data-testid="footer-email"
                  className="hover:text-white transition-colors break-all"
                >
                  {SITE.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#1E5BFF] mt-0.5" />
                <span data-testid="footer-address">{SITE.contact.address}</span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-xs font-bold uppercase tracking-[0.3em] text-[#1E5BFF] mb-5">
              Services
            </h4>
            <ul className="space-y-3 text-sm">
              {SITE.services.map((s) => (
                <li key={s.key}>
                  <a
                    href="#services"
                    className="text-slate-300 hover:text-white transition-colors font-display uppercase tracking-[0.15em] text-xs font-semibold"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#161616] flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <img
              src={SITE.assets.logo}
              alt="Coreline Heavy Haul & Hotshot"
              className="h-12 w-auto"
            />
            <div>
              <div className="font-display font-bold uppercase tracking-[0.18em] text-white text-sm">
                {SITE.brand}
              </div>
              <div className="text-xs text-slate-500 mt-1">{SITE.tagline}</div>
            </div>
          </div>
          <div className="text-xs text-slate-500 font-display uppercase tracking-[0.2em]">
            © {new Date().getFullYear()} Coreline Heavy Haul & Hotshot · {SITE.domain}
          </div>
        </div>
      </div>
    </footer>
  );
};
